(() => {
  const toast = (message) => { const el = document.querySelector('.wiiz-toast'); if (!el) return; el.textContent = message; el.classList.add('show'); clearTimeout(window.wiizToast); window.wiizToast = setTimeout(() => el.classList.remove('show'), 2200); };

  document.addEventListener('submit', async (event) => {
    const form = event.target.closest('.product-form');
    if (!form) return;
    event.preventDefault();
    const button = form.querySelector('[type="submit"]'); button.disabled = true;
    try {
      const response = await fetch(`${window.WIIZ.root}cart/add.js`, { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) });
      if (!response.ok) throw new Error((await response.json()).description || 'Could not add item');
      const cart = await fetch(`${window.WIIZ.root}cart.js`).then(r => r.json());
      document.querySelectorAll('[data-cart-count]').forEach(el => el.textContent = cart.item_count);
      toast('Added to your game-day bag');
    } catch (error) { toast(error.message); }
    finally { button.disabled = false; }
  });

  document.querySelectorAll('[data-product]').forEach(root => {
    const options = [...root.querySelectorAll('[data-option]')]; const variants = root.querySelector('[data-variant-select]');
    options.forEach(option => option.addEventListener('change', () => {
      const chosen = options.map(o => o.value); const match = [...variants.options].find(v => JSON.stringify(chosen) === v.dataset.options);
      if (match) { variants.value = match.value; root.querySelector('.product-submit').disabled = match.disabled; }
    }));
  });

  const loadSchedule = async (section) => {
    const grid = section.querySelector('[data-schedule-grid]'); const status = section.querySelector('[data-schedule-status]');
    const season = section.dataset.season || new Date().getFullYear(); const team = section.dataset.team || 'chi';
    const url = section.dataset.feed || `https://site.api.espn.com/apis/site/v2/sports/football/nfl/teams/${team}/schedule?season=${season}&seasontype=2`;
    try {
      const data = await fetch(url, { headers: { Accept: 'application/json' } }).then(r => { if (!r.ok) throw new Error(); return r.json(); });
      const events = data.events || data.items || [];
      if (!events.length) throw new Error();
      grid.innerHTML = events.map((event, index) => {
        const competition = event.competitions?.[0]; const competitors = competition?.competitors || [];
        const bears = competitors.find(c => (c.team?.abbreviation || '').toLowerCase() === team.toLowerCase());
        const opponent = competitors.find(c => c !== bears); const home = bears?.homeAway === 'home';
        const date = new Date(event.date); const dateText = isNaN(date) ? 'TBD' : new Intl.DateTimeFormat(undefined,{month:'short',day:'numeric'}).format(date).toUpperCase();
        const timeText = isNaN(date) ? 'TBD' : new Intl.DateTimeFormat(undefined,{hour:'numeric',minute:'2-digit'}).format(date);
        const week = event.week?.number || event.week?.text || index + 1; const completed = competition?.status?.type?.completed;
        const score = completed && bears?.score ? `${bears.score.displayValue || bears.score}–${opponent?.score?.displayValue || opponent?.score || ''}` : timeText;
        return `<article class="game"><small>WEEK ${week}</small><b>${dateText}</b><h3>${home ? 'VS' : 'AT'} ${(opponent?.team?.shortDisplayName || opponent?.team?.displayName || 'TBD').toUpperCase()}</h3><div><span>${score}</span><span>${home ? 'HOME' : 'AWAY'}</span></div></article>`;
      }).join('');
      status.textContent = `UPDATED LIVE · ${events.length} GAMES`;
    } catch (_) { status.textContent = 'LIVE FEED UNAVAILABLE · SHOWING STORE FALLBACK'; }
  };
  document.querySelectorAll('[data-schedule]').forEach(loadSchedule);
  document.addEventListener('shopify:section:load', e => e.target.querySelectorAll?.('[data-schedule]').forEach(loadSchedule));
})();
